import emailTemplate from '@/api/emailTemplate'

const getDefaultState = () => ({
    isLoading: false,
    templates: [],
    templateId: null
})

export default {
    namespaced: true,
    state: getDefaultState(),
    getters: {
        isLoading(state) {
            return state.isLoading
        },
        templates(state) {
            return state.templates
        }
    },
    mutations: {
        setIsLoading(state, { value }) {
            state.isLoading = value
        },
        resetTemplates(state) {
            state.templates = []
            state.templateId = null
        },
        updateTemplates(state, { results }) {
            state.templates = results
        },
        resetTemplate(state, { templateId }) {
            state.templateId = templateId
        }
    },
    actions: {
        async getAllEmailTemplates({commit}, payload) {
            commit('resetTemplates')
            commit('setIsLoading', {value: true})
            return await emailTemplate.getAllEmailTemplates(payload.limit, payload.offset)
        },
        async getEmailTemplateDetail({commit}, templateId) {
            commit('resetTemplate', templateId)
            commit('setIsLoading', {value: true})
            return await emailTemplate.getEmailTemplateDetail(templateId)
        },
        async saveEmailTemplateDetail({commit}, {templateId, payload}) {
            commit('setIsLoading', {value: true})
            return await emailTemplate.saveEmailTemplateDetail(templateId, payload)
        },
        async createEmailTemplate({commit}, payload) {
            commit('setIsLoading', {value: true})
            return await emailTemplate.createEmailTemplate(payload)
        },
        async removeEmailTemplate({commit}, templateId) {
            commit('setIsLoading', {value: true})
            return await emailTemplate.removeEmailTemplate(templateId)
        }
    }
}
